import type { AlgoliaDomain } from '../types'

import { useIsProxyActivated } from './useIsProxyActivated'

export type { AlgoliaDomain }

type AlgoliaSearchOptions =
  | {
      hosts: { url: string; protocol: string }[]
      headers: Record<string, string>
    }
  | {}

export function useAlgoliaSearchOptions(
  domain: AlgoliaDomain,
): AlgoliaSearchOptions {
  const { isProxyActivated, host } = useIsProxyActivated(domain)

  if (!isProxyActivated) return {}

  const serverOnlyHeaders = import.meta.server
    ? {
        'user-agent': 'bm-search-javascript-client',
      }
    : {}

  return {
    hosts: [{ url: host.value, protocol: 'https' }],
    headers: {
      'BM-Search-Domain': domain,
      ...serverOnlyHeaders,
    },
  }
}
